import { render } from "./order_content.vue?vue&type=template&id=29d611a8&scoped=true"
import script from "./order_content.vue?vue&type=script&lang=js"
export * from "./order_content.vue?vue&type=script&lang=js"

import "./order_content.vue?vue&type=style&index=0&id=29d611a8&scoped=true&lang=css"

import exportComponent from "/home/withpd/git/geek9_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29d611a8"]])

export default __exports__